const AUTH = 'auth';
const USER = 'user';
const ERROR = 'error';
const ORGANIZATION = 'organization';
const ROLEREQUEST = 'roleRequest';
const LICENSE = 'license';
const USERROLE = 'userRole';
const LANGUAGE = 'language';
const BESTLIST = 'bestList';
const PERFORMANCE = 'performance';
const CHECKING = 'checking';
const COMPETITION = 'competition';
const COMPETITIONAPPROVAL = 'compApproval';
const DEFINITIONS = 'definitions';
const EVENTREGISTRATION = 'eventregistration';
const RECORDS = 'records';
const MANUALBESTLISTS = 'manualbestlists';

export default {
	AUTH,
	USER,
	ERROR,
	ORGANIZATION,
	ROLEREQUEST,
	LICENSE,
	USERROLE,
	LANGUAGE,
	BESTLIST,
	PERFORMANCE,
	CHECKING,
	COMPETITION,
	COMPETITIONAPPROVAL,
	DEFINITIONS,
	EVENTREGISTRATION,
	RECORDS,
	MANUALBESTLISTS,
};
